import React from "react";
import ArrowForward from "@mui/icons-material/ArrowForward";
import BusinessCenter from "@mui/icons-material/BusinessCenter";
import CheckCircle from "@mui/icons-material/CheckCircle";
import TrendingUp from "@mui/icons-material/TrendingUp";
import Verified from "@mui/icons-material/Verified";
import { Box, Button, Card, CardContent, Typography } from "@mui/material";

import { BANNER_BENEFITS, BANNER_COPY } from "./constants";
import { advertiseNowBannerStyles as styles } from "./styles";
import { useAdvertiseNowNavigation } from "./useAdvertiseNowNavigation";

const BENEFIT_ICONS = {
  free: CheckCircle,
  visits: TrendingUp,
  "no-bureaucracy": Verified,
} as const;

type AdvertiseNowBannerProps = {
  propertyId?: number;
};

function AdvertiseNowBanner({ propertyId }: AdvertiseNowBannerProps) {
  const { handleAdvertiseClick } = useAdvertiseNowNavigation({ propertyId });

  return (
    <Box className="mt-10 w-full px-6">
      <Card sx={styles.card}>
        <CardContent sx={styles.cardContent}>
          <Box sx={styles.mainRow}>
            <Box sx={styles.contentGroup}>
              <Box sx={styles.iconContainer}>
                <BusinessCenter sx={styles.decorativeIcon} />
              </Box>

              <Box>
                <Typography component="h2" sx={styles.title}>
                  {BANNER_COPY.title}
                </Typography>
                <Typography sx={styles.description}>
                  {BANNER_COPY.description}
                </Typography>
              </Box>
            </Box>

            <Button
              onClick={handleAdvertiseClick}
              variant="contained"
              sx={styles.ctaButton}
              endIcon={<ArrowForward sx={styles.ctaIcon} />}
            >
              {BANNER_COPY.ctaLabel}
            </Button>
          </Box>

          <Box sx={styles.benefitsRow}>
            {BANNER_BENEFITS.map((benefit) => {
              const Icon = BENEFIT_ICONS[benefit.id];
              const isDesktopOnly = benefit.id === "no-bureaucracy";

              return (
                <Box
                  key={benefit.id}
                  sx={[
                    styles.benefitItem,
                    isDesktopOnly && styles.benefitItemDesktopOnly,
                  ]}
                >
                  <Icon sx={styles.benefitIcon} />
                  <Typography sx={styles.benefitLabelDesktop}>
                    {benefit.label}
                  </Typography>
                  <Typography sx={styles.benefitLabelMobile}>
                    {benefit.shortLabel}
                  </Typography>
                </Box>
              );
            })}
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}

export default AdvertiseNowBanner;
